<template>
  <div>
    <w-radio
      :title="filter.options.include.text"
      :model="schema.$eq"
      :value="filter.options.include.value"
      @click="schema.$ne.$setData(null)"
      @input="$emit('update')"
    />

    <w-radio
      class="mt-2"
      :title="filter.options.exclude.text"
      :model="schema.$ne"
      :value="filter.options.exclude.value"
      @click="schema.$eq.$setData(null)"
      @input="$emit('update')"
    />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz radio wykluczającego
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true },
    // filtr
    filter: { type: Object, required: true }
  }
};
</script>
